import { useOgpCompanyTypeContext } from 'ogp/limited-company-capabilities';
import { CheckoutsTypeProvider, useCheckoutsTypeProvider } from './checkouts-type-provider';
import { ProjectsCheckoutsInbox } from '../projects-checkouts/inbox/projects-checkouts-inbox';
import { CheckoutsInbox } from '../shifts-checkouts/inbox/checkouts-inbox';

const SharedCheckoutsInbox = () => {
  return (
    <CheckoutsTypeProvider>
      <CheckoutsInboxPage />
    </CheckoutsTypeProvider>
  );
};

const CheckoutsInboxPage = () => {
  const { isLimitedCompany } = useOgpCompanyTypeContext();
  const { type } = useCheckoutsTypeProvider();

  if (isLimitedCompany || type === 'shifts') {
    return <CheckoutsInbox />;
  }

  return <ProjectsCheckoutsInbox />;
};

export { SharedCheckoutsInbox };
